export const isAllowedNonNegativeDecimalInput = (value, integerOnly = false) => {
    if (value === '' || value === null || value === undefined) {
        return true;
    }
    const str = String(value);
    if (integerOnly) {
        return /^\d*$/.test(str);
    }
    if (!/^\d*[,.]?\d*$/.test(str)) {
        return false;
    }
    return (str.replace(',', '.').match(/\./g) || []).length <= 1;
};

export const normalizeNumericInputValue = (previousValue, nextValue, integerOnly = false) => {
    const next = String(nextValue ?? '');
    if (next === '') {
        return next;
    }
    const hasDecimalSeparator = next.includes('.') || next.includes(',');
    if ((integerOnly || !hasDecimalSeparator) && /^0\d+$/.test(next)) {
        return next.replace(/^0+/, '') || '0';
    }
    return next;
};

export const isNegativeNumber = (value) => {
    const num = parseFloat(String(value).replace(',', '.'));
    return !isNaN(num) && num < 0;
};
